angular.module("app").controller("AddUserPageController", [
    '$scope',
    'preloadedRoles',
    'userService',
    'errorHandler',
    'logger',
    function ($scope, preloadedRoles, userService, errorHandler, logger) {

        $scope.roles = angular.copy((preloadedRoles) ? preloadedRoles.roles : []);

        $scope.user = {};

        $scope.tooltip = {
            name: "",
            userName: "",
            confirmPassword: "",
            password: ""
        };


        $scope.submitAddUserForm = function () {
            var requestData = {
                user: angular.copy($scope.user)
            };
            requestData.user.re_password = $scope.add_user_form.confirmPassword.$viewValue;
            userService.createUser(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.user = {};
                        $scope.add_user_form.$setPristine && $scope.add_user_form.$setPristine();
                        logger.logSuccess("User has been successfully created")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
    }
]);